import type { QualificationResult, WizardAnswers, Lang } from "./types";

export interface QualifyResponse {
  ok: true;
  submission_id: string;
  result: QualificationResult;
}

export interface QualifyError {
  ok: false;
  error: string;
}

export async function postQualify(
  lang: Lang,
  answers: WizardAnswers,
  source?: string,
): Promise<QualifyResponse | QualifyError> {
  try {
    const res = await fetch("/api/qualify", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ lang, answers, source }),
    });
    if (!res.ok) {
      const text = await res.text().catch(() => "");
      return { ok: false, error: `HTTP ${res.status}: ${text || res.statusText}` };
    }
    return (await res.json()) as QualifyResponse;
  } catch (err) {
    return { ok: false, error: err instanceof Error ? err.message : "network_error" };
  }
}

export interface AiClarifyResponse {
  suggested_choice: string | null;
  follow_up_question: string | null;
  reasoning: string;
}

export async function postAiClarify(input: {
  lang: Lang;
  question_id: string;
  question_label: string;
  options: { value: string; label: string }[];
  user_phrase: string;
}): Promise<AiClarifyResponse | { error: string }> {
  try {
    const res = await fetch("/api/ai-clarify", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(input),
    });
    if (!res.ok) {
      return { error: `HTTP ${res.status}` };
    }
    return (await res.json()) as AiClarifyResponse;
  } catch (err) {
    return { error: err instanceof Error ? err.message : "network_error" };
  }
}
